import React from 'react';

interface CreatonStudioLogoProps {
  className?: string;
}

export const CreatonStudioLogo: React.FC<CreatonStudioLogoProps> = ({ className }) => {
  return (
    <div style={{ height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <img
        src="/images/logos/creaton-logo.png"
        alt="Creaton Studio"
        width={200}
        height={50}
        className={`dark:hidden ${className || ''}`}
        style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
      />
      <img
        src="/images/logos/creaton-logo-dark.png"
        alt="Creaton Studio"
        width={200}
        height={50}
        className={`hidden dark:block ${className || ''}`}
        style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
      />
    </div>
  );
};
